import { render, staticRenderFns } from "./ChromosomesSection.vue?vue&type=template&id=16e0ddcc&scoped=true&"
import script from "./ChromosomesSection.vue?vue&type=script&lang=js&"
export * from "./ChromosomesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e0ddcc",
  null
  
)

export default component.exports